<template>
  <div id="app" :class="bodyClasses">
    <header>
      <router-link class="btn logo" to="/">
        <img src="/static/img/cl_ethek_logo_new.svg">
      </router-link>
       <router-link class="btn viewMap" to="/map"><i class="icon-location"></i>View Interactive Map</router-link>
       <a href="https://data.ethekwinifews.durban/" target="_blank" class="btn viewMap"><i class="icon-search"></i>Get Datafeeds</a>
      <router-link class="btn" to="/report"><i class="icon-report"></i></router-link>
      <router-link v-if="user" class="btn" to="/profile"><i class="icon-user"></i></router-link>
      <router-link v-if="!user" class="btn" to="/login"><i class="icon-user"></i></router-link>
    </header>
    <div class="main">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <RainAlertModal v-if="this.showModal == 'rainModal'"></RainAlertModal>
      <WavesAlertModal v-if="this.showModal == 'wavesModal'"></WavesAlertModal>
      <WindAlertModal v-if="this.showModal == 'windModal'"></WindAlertModal>
    </div>
    <div class="responseGate">
      <img src="/static/img/logo.svg">
      <p>This web app is best experienced in portrait mode. <br/>Please rotate your device.</p>
    </div>

    <!-- =========================== HOME SCREEN DETECT UI ============================================================================== -->

    <div id="addHomScreen" v-if="isAddedHome == false">
      <button class="closeBtn btn btn-faded" @click="homeScreen">x</button>
      <img class="appIcon" src="/static/img/icons/android-chrome-192x192.png" alt="">
      Install this to your homescreen.<br/>
      <div class="iosInfo">
        Tap <img class="shareIcon" src="/static/img/install/icon-ios-share.png" alt=""> <b>Share</b>,
        <br/>then <img class="homescreenIcon" src="/static/img/install/icon-ios-add-to-homescreen.png" alt=""><b>Add to Home Screen</b>
      </div>
      <div class="androidInfo">
        Tap <img class="shareIcon" src="/static/img/install/icon-android-menu.png" alt=""> <b>Menu</b>,
        <br/>then <b>Add to Home Screen</b>
      </div>
    </div>
  </div>
</template>

<script>
// import geolib from 'geolib'
// import { mapActions } from 'vuex'
import RainAlertModal from './components/modals/RainAlertModal.vue'
import WavesAlertModal from './components/modals/WavesAlertModal.vue'
import WindAlertModal from './components/modals/WindAlertModal.vue'

export default {
  components: {
    RainAlertModal,
    WavesAlertModal,
    WindAlertModal
  },
  data: function () {
    return {
      isAddedHome: false,
      alertCardModal: false
    }
  },
  name: 'app',
  mounted: function () {
    if ((window.screen.height - window.innerHeight) > 80) {
      this.isAddedHome = false
    } else {
      this.isAddedHome = true
    }
    this.$store.state.showModal = false

    var OneSignal = window.OneSignal || []
    OneSignal.push(() => {
      OneSignal.init({
        appId: process.env.VUE_APP_ONESIGNAL,
        autoResubscribe: true,
        allowLocalhostAsSecureOrigin: true,
        welcomeNotification: {
          title: 'Coastal Live',
          message: 'We will keep you posted!'
        },
        promptOptions: {},
        notifyButton: {
          enable: false
        }
      })
      OneSignal.on('subscriptionChange', (isSubscribed) => {
        if (isSubscribed) {
          OneSignal.getUserId((userId) => {
            this.$axios.post('/auth/notificationuserid', {
              key: userId
            })
          })
        }
      })
    })
  },
  methods: {
    homeScreen () {
      this.isAddedHome = true
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    bodyClasses () {
      let classes = this.$route.name.toLowerCase() + 'Screen'
      if (this.user && this.user.profile && this.user.profile.dark_mode === 1) {
        classes += ' darkmode'
      }
      return classes
    },
    showModal () {
      return this.$store.state.showModal
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue